module.exports = __webpack_public_path__ + "static/media/queen_heart.3c435207.png";